/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseDefinition {
    getFixupPrototypeFunction() { return BaseDefinition.fixupPrototype; }

    static newInstance(model: Partial<BaseDefinition>): BaseDefinition {
        let obj = Object.assign(new BaseDefinition(), model);
        BaseDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseDefinition>): BaseDefinition {
        if (!model) return null;
        return BaseDefinition.newInstance(<BaseDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseDefinition) {
        if (!obj) return;

        models.BaseDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseDefinition): boolean {
        Object.setPrototypeOf(obj, BaseDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.createdOn === "string") {
            this.createdOn = new Date(<string><any>this.createdOn);
        }
        if (typeof this.updatedOn === "string") {
            this.updatedOn = new Date(<string><any>this.updatedOn);
        }
        if (this.headVersion) {
            models.RecordIdentity.fixupPrototype(this.headVersion);
        }
        if (this.releaseVersion) {
            models.RecordIdentity.fixupPrototype(this.releaseVersion);
        }
    }

    /**
     * Identifier of the definition
     */
    sysId: string;

    /**
     * Definition created on
     */
    createdOn: Date;

    /**
     * Definition updated on
     */
    updatedOn: Date;

    /**
     * Reference to the editable version of the definition
     */
    headVersion: models.RecordIdentity;

    /**
     * Reference to the release version of the definition
     */
    releaseVersion: models.RecordIdentity;

}
